import Button from '@components/Button';
import PillarListItem from '@components/PillarListItem';
import Prose from '@components/Prose';
import { ListType } from '@data/types';
import useStore from '@store/store';
import React from 'react';
import { hash } from 'utilities/helper';

interface Props extends ListType {
  as?: keyof JSX.IntrinsicElements;
}

const List: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent,
  pillarList,
  button,
}) => {
  const { setPage } = useStore();

  return (
    <Component className="w-full bg-blue">
      <div className="max-w-outerGrid mx-auto overflow-hidden px-4 py-16 xl:py-24 xl:px-0 xl:py-24">
        <div className="w-full h-full flex items-center mb-8">
          <div className="md:w-3/4">
            <Prose htmlContent={htmlContent} />
          </div>
          <div className="hidden md:w-1/4">&nbsp;</div>
        </div>

        <ul className="flex flex-wrap -mx-4 md:-mx-8 mb-8">
          {pillarList.map((item) => (
            <PillarListItem {...item} key={hash(item)} />
          ))}
        </ul>

        {button && (
          <div className="flex justify-center">
            <Button
              {...button}
              type="button"
              onClick={() => {
                window.scrollTo(0, 0);
                setPage('the_assessment');
              }}
            />
          </div>
        )}
      </div>
    </Component>
  );
};

export default List;
